import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {

  constructor() { }

  /**
   * Identify a user in PostHog with their unique ID and optional properties
   * Call this after login or when user data becomes available
   */
  identify(distinctId: string, properties?: Record<string, any>): void {
    if (!distinctId) {
      console.warn('PostHog identify called without distinctId');
      return;
    }
    posthog.identify(distinctId, properties);
  }

  /**
   * Reset PostHog state - call this on logout
   * This unlinks future events from the current user
   */
  reset(resetDeviceId: boolean = false): void {
    posthog.reset(resetDeviceId);
  }

  /**
   * Capture a custom event
   */
  capture(eventName: string, properties?: Record<string, any>): void {
    posthog.capture(eventName, properties);
  }

  /**
   * Set person properties without capturing an event
   */
  setPersonProperties(properties: Record<string, any>): void {
    posthog.setPersonProperties(properties);
  }

  /**
   * Get the current distinct ID
   */
  getDistinctId(): string {
    return posthog.get_distinct_id();
  }
}
